<template>
    <form :class="[isRenderedOnModal ? 'modal-rendered' : '',   'reset-password-link-to-email']" @submit.prevent="sendResetLinkToEmail">
        <h1 class="text-black-1 fs-24 fw-600 mb-1 reset-password-link-to-email__primary-heading">Enter Your Registered Email</h1>
        <p class="text-dark-grey-1 fs-16 fw-400">Please enter your email to initiate a password reset process.</p>

        <!-- Email field begins  -->

        <div class="form-group mb-3 mt-3">
            <SfeLabel for="email-password-reset-link" required class='mb-1'>
                Email
            </SfeLabel>
            <b-form-input id="email-password-reset-link" placeholder="example@gmail.com" type="email" class="form-control border-radius-8 py-4" v-model="form.email"></b-form-input>
            <ShrInputError :error="errors.email" />
        </div>

        <!-- Email field ends -->


        <!-- Button container starts -->

        <div class="text-center mb-3 mt-2">
        <SfeButton size="lg" :disabled="buttonIsDisabled" type="submit" class="btn fs-18 fw-400 text-center btn-primary-light-blue border-radius-8 py-3 d-flex align-items-center justify-content-center w-100">
            Get started <SfeLoader v-if="isLoading" class="ml-1" size="sm" color="white" />
        </SfeButton>
        </div>

        <!-- Button container ends -->

        <div class="text-center">
            <p class="text-light-grey-1 d-inline">Remember password? go back to<a href="#" @click="$emit('show-login-form')" class="text-primary ml-1 mt-2">Login</a></p>
        </div>
    </form>
</template>

<script>
    import UserModel from '../../models/UserModel';
    export default {
        data() {
            return {
                form: {
                    email: '',
                    user_type: this.$route.params.userType
                },
                errors: {},
				isLoading: false
            }
        },
        props: {
            isCandidateResetPassword: {
                type: Boolean,
                default: true
            },
            isRenderedOnModal: {
                type: Boolean,
                default: false
            }
        },
		mixins: [UserModel],
        methods: {
            sendResetLinkToEmail() {
                this.isLoading = true
                this.UserModel.sendPasswordLinkToEmail(this.form)
                    .then(r => {
                        this.isLoading = false
                    }).finally(this.$emit('reset-link-to-email:successful'))
            }
        },	 
        computed: {
            buttonIsDisabled() {
                return !this.form.email
            }
        }
    }
</script>

<style lang="scss" scoped>
@media screen and (min-width: 320px) {
	.reset-password-link-to-email {
        padding: 20px 12px 24px 12px;
        border-radius: 4px;
        background-color: #FCFCFD;
        min-height: 100vh;
		&__seamless-jobs-logo {
			display: inline-block
		}
        &__primary-heading {
            margin-top: 1rem;
        }
    }
}
@media screen and (min-width: 768px) {
	.reset-password-link-to-email {
        padding: 100px 80px;
        max-width: 50%;
        margin: 0 auto 0 auto;
        background-color: #ffffff;
        text-align: center;
        &.modal-rendered {
            max-width: 80%;
            padding: 10px 8px;
            min-height: 0;
        }
		&__seamless-jobs-logo {
			display: none
		}
        &__primary-heading {
            margin-top: 0;
        }
    }
}
</style>